import { useReducer } from 'react';
import { TRANSPORT_FILTERS_ACTIONS, transportFiltersReducer } from './transportFiltersReducer';
import { defaultState, initReducer } from './transportFiltersReducer.utils';
export const useTransportFilters = (transports: Array<AlternativeTransport>) => {
  const [state, dispatch] = useReducer(
    transportFiltersReducer,
    initReducer(defaultState, transports),
  );

  const updateFilters = (key: TransportFiltersKeys, value: string | TransportDateRange) => {
    dispatch({
      type: TRANSPORT_FILTERS_ACTIONS.UPDATE,
      payload: {
        key,
        value,
      },
    });
  };

  const resetFilters = () => {
    dispatch({
      type: TRANSPORT_FILTERS_ACTIONS.RESET,
    });
  };

  return {
    state,
    updateFilters,
    resetFilters,
  };
};
